import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
// components
import Subnavigation from 'components/Subnavigation';
import OfflineScreen from 'components/OfflineScreen';
import DataTableImports from './DataTableImports/DataTableImports';

// Import id and type come from the route so the page also works when opened by a direct link
const ImportsTable = ({ isOnline, subNavLinks, params }) => (
  <div className="BarnsheetsHome clearfix">
    <Subnavigation isSticky links={subNavLinks} className="small-12 column" />
    {isOnline ? (
      <div className="small-12 column">
        <DataTableImports
          getDataUrl={`/admin/csv_imports/${params.id}`}
          getNameStore={`${params.nameType}ImportResult`}
          params={params}
        />
      </div>
    ) : (
      <OfflineScreen />
    )}
  </div>
);

ImportsTable.propTypes = {
  isOnline: T.bool,
  subNavLinks: T.array,
  params: T.shape({
    id: T.string.isRequired,
    nameType: T.string.isRequired,
  }).isRequired,
};

export default withRouter(connect((state) => ({
  isOnline: state.network.isOnline,
}))(ImportsTable));
